// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1WVIM","list":"BalanceDue_list__1MuoA","listRow":"BalanceDue_listRow__3cYlh","total":"BalanceDue_total__3RtTx"};